export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "excel-parser.worker.e96e6fea34dbce8c.worker.js");
}
